import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

const AssemblyData = ({ meeting }) => {
  const lan = localStorage.getItem("i18nextLng");
  const { t } = useTranslation();
  const { lng } = useSelector((store) => store.language);

  return (
    <AssemblyDataBox>
      <h3 className="assembly-data-title">{t("meetingData")}</h3>

      <ul className="assembly-data-list">
        <li className="assembly-data-item">
          <span className="assembly-data-item-text1">{t("idProtocol")}</span>
          <p className="assembly-data-item-text2">{meeting?.protocolNumber}</p>
        </li>

        <li className="assembly-data-item">
          <span className="assembly-data-item-text1">{t("meetingDay")}</span>
          <p className="assembly-data-item-text2">
            {meeting?.startDate.slice(0, 10)}
          </p>
        </li>

        <li className="assembly-data-item">
          <span className="assembly-data-item-text1">
            {t("meetingAddress")}
          </span>
          <p className="assembly-data-item-text2">
            {meeting?.city
              ? meeting.city[`name${lan.replace(lan[0], lan[0].toUpperCase())}`]
              : ""}
          </p>
        </li>

        {meeting.meetingType == "OFLINE" && (
          <li className="assembly-data-item">
            <span className="assembly-data-item-text1">{t("time")}</span>
            <p className="assembly-data-item-text2">
              {new Date(meeting?.startDate).toLocaleTimeString()}
            </p>
          </li>
        )}

        {meeting[`address_${lng}`] && (
          <li className="assembly-data-item">
            <span className="assembly-data-item-text1">
              {t("meetingsList.address")}
            </span>
            <p className="assembly-data-item-text2">
              {meeting[`address_${lng}`]}
            </p>
          </li>
        )}
      </ul>

      {meeting.meetingType == "OFLINE" && (
        <p className="text-box">
          <span className="assembly-data-item-text1">
            {t("meetingsList.commentMeeting")}
          </span>
          <span className="assembly-data-item-text2">
            {meeting[`introduction_${lng}`]}
          </span>
        </p>
      )}
    </AssemblyDataBox>
  );
};

export default AssemblyData;

const AssemblyDataBox = styled.div`
  padding: 20px 0 20px 0 !important;
  border-top: 2px solid #ddf8f0;
  border-bottom: 2px solid #ddf8f0;
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  .assembly-data-title {
    margin-bottom: 20px !important;
    font-size: 22px;
  }

  .assembly-data-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 332px));
    column-gap: 62px;
    row-gap: 15px;
  }

  .text-box {
    margin-top: 15px;
  }

  .assembly-data-item-text1,
  .assembly-data-item-text2 {
    display: block;
  }

  .assembly-data-item-text1 {
    color: #5d6b8a;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
`;
